import Vue from 'vue';
import Router from 'vue-router';
import HomePage from '@/components/HomePage.vue';
import ThreeJSComponent from '@/components/ThreeJSComponent.vue';
import RoadNet from '@/components/RoadNet.vue';
import TrafficFlow from '@/components/TrafficFlow.vue';
import BeiHong from '@/components/bridge/BeiHong.vue';
import SandBox from '@/components/SandBox.vue';
import SandBoxWuhan from '@/components/Sandbox_wuhan.vue';
import SandBox_shenzhen from '@/components/SandBox_shenzhen.vue';
import ModelMain from '@/components/ModelMain.vue';
import ModelMainwh from '@/components/ModelMainwh.vue';
import Sandbox_wuhan_English from '@/components/Sandbox_wuhan_English.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
    },
    {
      path: '/roadnet',
      name: 'RoadNet',
      component: RoadNet,
      meta: { requiresAuth: true }   // 标记为需要登录
    },
    {
      path: '/model',
      name: 'Model',
      component: ThreeJSComponent,
      meta: { requiresAuth: true }
    },
    {
      path: '/BeiHong',
      name: 'BeiHong',
      component: BeiHong,
      meta: { requiresAuth: true }
    },
    {
      path: '/trafficflow',
      name: 'TrafficFlow',
      component: TrafficFlow,
      meta: { requiresAuth: true }
    },
    {
      path: '/sandbox',
      name: 'SandBox',
      component: SandBox,
      meta: { requiresAuth: true }
    },
    {
      path: '/SandboxWuhan',
      name: 'SandBoxWuhan',
      component: SandBoxWuhan,
      meta: { requiresAuth: true }
    },
    {
      path: '/sandbox_shenzhen',
      name: 'SandBox_shenzhen',
      component: SandBox_shenzhen,
      meta: { requiresAuth: true }
    },
    {
      path: '/ModelMain',
      name: 'ModelMain',
      component: ModelMain,
      meta: { requiresAuth: true }
    },
    {
      path: '/ModelMainwh',
      name: 'ModelMainwh',
      component: ModelMainwh,
      meta: { requiresAuth: true }
    },
    {
      path: '/Sandbox_wuhan_English',
      name: 'Sandbox_wuhan_English',
      component: Sandbox_wuhan_English,
      meta: { requiresAuth: true }
    }
  ],
});

router.beforeEach((to, from, next) => {
  // 1. 处理 URL 上的 token
  const tokenParam = to.query.token;
  if (tokenParam) {
    localStorage.setItem('token', tokenParam);
    const newQuery = { ...to.query };
    delete newQuery.token;
    next({ path: to.path, query: newQuery, replace: true });
    return;
  }

  // 2. 需要登录的路由
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const userId = localStorage.getItem('token');
    if (!userId) {
      // 防止重复重定向
      if (to.path === '/' && to.query.needLogin) {
        next();
      } else {
        next({ path: '/', query: { needLogin: '1' } });
      }
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;